export const PRESENSI_GET = 'PRESENSI_GET';